import { useContext } from 'react'
import { GlobalContext } from 'App'
import { motion } from 'framer-motion';
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties';

const First = ({ activeIndex }: any) => {
  const { isTablet } = useContext(GlobalContext)

  return (
    <div className={`flex w-full h-screen overflow-hidden justify-center items-center select-none`}>
      <div className='tablet:bg-[rgba(0,0,0,0.8)] tablet:p-12.5 container'>
        <motion.p
          className={`${isTablet ? 'text-32' : 'text-8xl mb-16'}  text-white`}
          style={{ textShadow: '0 0 14px white' }}
          transition={{ delay: 0.4 }}
          initial={START_ANIMATION_PROPERTY}
          whileInView={END_ANIMATION_PROPERTY}
          viewport={VIEWPORT_PROPERTY} >
          ABOUT
        </motion.p>

        <motion.p
          className='mb-2 text-[#282828] text-3xl'
          transition={{ delay: 0.4 }}
          initial={START_ANIMATION_PROPERTY}
          whileInView={END_ANIMATION_PROPERTY}
          viewport={VIEWPORT_PROPERTY} >
          Who We Are.
        </motion.p>

        <motion.p
          className={`${isTablet ? 'text-xs' : 'text-lg'} text-white`}
          transition={{ delay: 0.6 }}
          initial={START_ANIMATION_PROPERTY}
          whileInView={END_ANIMATION_PROPERTY}
          viewport={VIEWPORT_PROPERTY} >
          치열한 경쟁과 빠르게 변화하는 정보통신 기술 분야에서, 우리는 TINS LAB만의 독자적인 아이덴티티를 만들어갑니다.
        </motion.p>
        <motion.p
          className={`${isTablet ? 'text-xs' : 'text-lg'} text-white`}
          transition={{ delay: 0.6 }}
          initial={START_ANIMATION_PROPERTY}
          whileInView={END_ANIMATION_PROPERTY}
          viewport={VIEWPORT_PROPERTY} >
          고객과 함께 소통하며, 고객의 관점에서 사고합니다. 이를 통해 고정관념에 얽매이지 않고, 획일화된 IT 제품을 넘어,
        </motion.p>
        <motion.p
          className={`${isTablet ? 'text-xs' : 'text-lg'} text-white`}
          transition={{ delay: 0.6 }}
          initial={START_ANIMATION_PROPERTY}
          whileInView={END_ANIMATION_PROPERTY}
          viewport={VIEWPORT_PROPERTY} >
          소비자의 니즈에 맞춘 새로운 솔루션을 제시합니다.
        </motion.p>
      </div>
    </div>
  )
}

export default First